import React, { useEffect, useRef, useState } from "react";
import { CSVLink } from "react-csv";
import _ from "lodash";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment-timezone";
import ModalCustom from "../../Common/ModalCustom";
import SearchBox from "../../Common/SearchBox";
import Loader from "../../Common/Loader";
import ActiveSuccessor from "./ActiveSuccessor";
import ArchivedSuccessor from "./ArchivedSuccessor";
import { GetSuccessorListing } from "../../../redux/features/SuccessorService";
import AddSuccessorPopup from "./AddSuccessorPopup";

const SuccessorUser = () => {
  const dispatch = useDispatch();
  const [activeTab, setActiveTab] = useState(0);
  const [loading, setLoading] = useState(false);
  const tabs = ["Active", "Inactive"];
  const { getSuccessorListing } = useSelector((state) => state.successor);
  const [showPopup, setShowPopup] = useState(false);
  const [csvData, setCsvData] = useState([]);
  const [search, setSearch] = useState("");
  const [filteredData, setFilteredData] = useState(null);
  const [isCsvDataShow, setCsvDataShow] = useState(false);
  
  const handleSearch = (searchText) => {
    setSearch(searchText);
  };

  const csvLink = useRef();
  const handleCsvDownload = async () => {
    try {
      setLoading(true);
      const response = await dispatch(
        GetSuccessorListing({
          search: search,
          role: 4,
          csv: true,
          status: activeTab === 1 ? "0" : "1",
        })
      );

      const appendedData = _.map(response?.payload?.data, (data) => {
        return {
          firstName: data.firstName,
          lastName: data.lastName,
          email: data.email,
          phoneNumber: data.phoneNumber,
          createdAt: moment
            (data.createdAt)
            .format("MM/DD/yyyy @ HH:mm PT"),
          updatedAt: moment
            (data.updatedAt)
            .format("MM/DD/yyyy @ HH:mm PT"),
        };
      });
      if (Array.isArray(appendedData)) {
        const sortedData = _.sortBy(appendedData, 'firstName');
        setCsvData(sortedData);
        setCsvDataShow(true);
      } else {
        console.error("Invalid data format for CSV export");
      }
    } catch (e) {
      console.error(e);
    }
    finally{
      setLoading(false);
    }
  };

  useEffect(() => {
    if (csvData?.length > 0 && isCsvDataShow) {
      csvLink.current.link.click();
      setCsvDataShow(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [csvData]);

  const headers = [
    { label: "First Name", key: `firstName` },
    { label: "Last Name", key: `lastName` },
    { label: "Email", key: "email" },
    { label: "Phone Number", key: "phoneNumber" },
    { label: "Last Session", key: "createdAt" },
    { label: "Last Updated", key: "updatedAt" },
  ];

  // handle search
  useEffect(() => {
    if (search.trim() === "") {
      setFilteredData(getSuccessorListing?.data);
    } else {
      const filtered = _.filter(
        getSuccessorListing?.data,
        (item) =>
        (item?.firstName?.trim().toLowerCase().includes(search.trim().toLowerCase())) ||
        (item?.lastName?.trim().toLowerCase().includes(search.trim().toLowerCase())) ||
        ((item?.email && item?.email.trim().toLowerCase().includes(search.trim().toLowerCase()))) || // NOSONAR
        ((item?.phoneNumber && item?.phoneNumber.trim().includes(search.trim()))) // NOSONAR
      );
      setFilteredData(filtered);
    }
  }, [search, getSuccessorListing]);


  return (
    <>
      {loading && <Loader />}
      <div className="w-100">
        <div className="title_bar d-flex align-items-center justify-content-between">
          <div className="text-style">
            Successor Users
          </div>
          <div className="d-flex">
            {getSuccessorListing.data && (
              <>
                <button
                  className="btn btn-transparant mx-2"
                  onClick={handleCsvDownload}
                >
                  Export CSV
                </button>
                <CSVLink
                  data={csvData}
                  filename="Successor-User"
                  ref={csvLink}
                  headers={headers}
                />
              </>
            )}
            <button
              className="btn btn-thm"
              onClick={(e) => {
                e.preventDefault();
                setShowPopup(true);
              }}
            >
              Add Successor User
            </button>
          </div>
        </div>

        <div className="conten-div">
          <div className="d-flex justify-content-between">
            <SearchBox handleSearch={handleSearch} search={search} />
          </div>
          <div className="d-flex mt-4">
            {_.map(tabs, (tab, tabIndex) => (
              <div // NOSONAR
                onClick={(e) => {
                  e.preventDefault();
                  setSearch("");
                  setLoading(true);
                  setTimeout(() => {
                    setLoading(false);
                  }, 1000);
                  setActiveTab(tabIndex);
                }}
                className={`tab-link ${activeTab === tabIndex ? "active" : ""}`}
                key={`${tab}-${tabIndex}-SuccessorUsers`}
              >
                {tab}
              </div>
            ))}
          </div>
          <div className="TableData mt-4">
            {activeTab === 0 && <ActiveSuccessor filteredData={filteredData} />}
            {activeTab === 1 && <ArchivedSuccessor filteredData={filteredData} />}
          </div>
        </div>
      </div>
      <ModalCustom size="xs" show={showPopup}>
        <AddSuccessorPopup setShowSuccessorUserPopup={setShowPopup} />
      </ModalCustom>
    </>
  );
};

export default SuccessorUser;
